import ErrorPageContent from './ErrorPageContent'

export default ErrorPageContent
